import React from "react";
import { InlineRichTextEdit } from "./InlineRichTextEdit";
import { StoryNode } from "../StoryBook/StoryData";

export const InlineRichEditStories = [
    new StoryNode(
        () => {
            return <InlineRichTextEdit />;
        },
        "Shared",
        "Building Blocks",
        "Inline Rich Edit",
        "Default"
    ),
    new StoryNode(
        () => {
            return <InlineRichTextEdit showToolsOnFocus={true} />;
        },
        "Shared",
        "Building Blocks",
        "Inline Rich Edit",
        "Show Tools On Focus"
    ),
];
